'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_RIGHT = 39;
var KEY_LEFT = 37;

var Gallery = function (_Component) {
  (0, _inherits3.default)(Gallery, _Component);

  function Gallery(props) {
    (0, _classCallCheck3.default)(this, Gallery);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Gallery.__proto__ || (0, _getPrototypeOf2.default)(Gallery)).call(this, props));

    _this.state = {
      currentImage: 0,
      loaded: props.images.map(function (img, i) {
        return i == 0 ? true : false;
      })
    };
    return _this;
  }

  (0, _createClass3.default)(Gallery, [{
    key: 'gotoImage',
    value: function gotoImage(newImage) {
      var loaded = this.state.loaded;

      loaded[newImage] = true;

      this.setState({ currentImage: newImage, loaded: loaded });
    }
  }, {
    key: 'nextImage',
    value: function nextImage() {
      var loaded = this.state.loaded;


      var nextImage = (this.state.currentImage + 1) % this.props.images.length;
      loaded[nextImage] = true;

      this.setState({ currentImage: nextImage, loaded: loaded });
    }
  }, {
    key: 'prevImage',
    value: function prevImage() {
      var loaded = this.state.loaded;


      var nextImage = (this.state.currentImage || this.props.images.length) - 1;
      loaded[nextImage] = true;

      this.setState({ currentImage: nextImage, loaded: loaded });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (e.keyCode == KEY_RIGHT) {
        this.nextImage();
      } else if (e.keyCode == KEY_LEFT) {
        this.prevImage();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onKeyDown = this.onKeyDown.bind(this);
      window.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var images = this.props.images;
      var _state = this.state,
          currentImage = _state.currentImage,
          loaded = _state.loaded;

      var label = images && images.length > currentImage && images[currentImage].label || '';

      var styles = require('./AssetPopupImageViewer.scss');

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.dots, true), (0, _defineProperty3.default)(_classnames, styles.hide, this.props.images.length <= 1), _classnames));

      return _react2.default.createElement(
        'div',
        { className: this.props.className, style: { height: '100%' } },
        _react2.default.createElement(
          'ul',
          { className: styles.gallery },
          images.map(function (image, i) {
            if (loaded[i]) return _react2.default.createElement('li', { className: i === currentImage ? styles.active : '', style: { backgroundImage: 'url(\'' + image.uri + '\')' } });else return null;
          })
        ),
        _react2.default.createElement(
          'ul',
          { className: classes },
          images.map(function (image, i) {
            return _react2.default.createElement(
              'li',
              { className: i === currentImage ? styles.active : '' },
              _react2.default.createElement('button', { onClick: function onClick(e) {
                  e.preventDefault;_this2.gotoImage(i);
                } })
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.images.length <= 1 ? styles.hide : styles.label },
          label
        )
      );
    }
  }]);
  return Gallery;
}(_react.Component);

exports.default = Gallery;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetPopupImageViewer/AssetPopupImageViewer.jsx
// module id = 2434
// module chunks = 0